import React from 'react';
import styled from 'styled-components';
import { UIProps } from '../../types/StyledProps';
import mergeClassNames from '../../lib/style-helpers/merge-class-name';
import { DropEventProps } from '../../types/DropEventProps';

export type DropAreaProps = React.PropsWithoutRef<DropEventProps & UIProps>;

function DropArea({
  className,
  ...props
}: DropAreaProps) {
  return (
    <Container
      className={mergeClassNames('DropArea', className)}
      {...props}
    />
  );
}

const Container = styled.div``;

export default DropArea;
